import { useNavigate } from "react-router-dom";

// navigate(-1) (and window.history.length > 1, which is true almost always
// since it counts the page the browser was on before this site too) sends
// the browser straight past the whole app to whatever was open before it —
// often an external site, like the Google results page a member clicked in
// from — whenever they land on a page directly instead of clicking to it
// from inside the app. react-router's history library stamps every entry
// it pushes with an incrementing `idx` in history.state, so idx > 0 means
// there's at least one in-app entry to go back to; idx 0 (or missing, e.g.
// a hard refresh) means this is the first entry in the tab and we should
// send the member to an in-app page instead of leaving the site.
export function useSmartBack(fallback = "/feed") {
  const navigate = useNavigate();
  return () => {
    const idx = window.history.state?.idx;
    if (typeof idx === "number" && idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  };
}
